export default "__VITE_ASSET__vqDfYV_I__"